"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Button = __importStar(require("./A_Button"));
var Component = function (p) {
    return (Preact.h(Box_1.default, { sx: {
            display: 'flex',
            justifyContent: 'space-between',
            border: '1px solid',
            borderColor: 'primary',
            marginBottom: '8px',
        } },
        Preact.h(Box_1.default, null,
            Preact.h(Typography_1.default, null,
                "Kind: ",
                p.kind,
                " "),
            Preact.h(Typography_1.default, null,
                "Format: ",
                p.format,
                " "),
            p.location ? Preact.h(Typography_1.default, null,
                "Location:",
                p.location,
                " ") : null,
            p.created ? Preact.h(Typography_1.default, null,
                "Created:",
                p.created,
                " ") : null,
            p.lastModified ? Preact.h(Typography_1.default, null,
                "Last updated:",
                p.lastModified,
                " ") : null),
        Preact.h(Box_1.default, { sx: { display: 'flex', flexDirection: 'column' } },
            p.location ? (Preact.h(Button.Component, { variant: "outlined", onClick: function () { return console.log('call onUpdate'); } }, "Update")) : (Preact.h(Button.Component, { variant: "outlined", onClick: function () { return console.log('call onUpload'); } }, "Upload")),
            Preact.h(Button.Component, { variant: "outlined", onClick: function () { return p.location && p.onDownload(p.location); }, disabled: !p.location }, "Download"))));
};
exports.Component = Component;
